export default {
  EMAIL_INTEGRATION_RECEIVED_SUMMARY:
    '{recipients} received an {interactionIcon} email from {sender} on {date}.',
  EMAIL_INTEGRATION_RECEIVED_BCC_ONLY_SUMMARY:
    '{bccRecipients} received a BCC {interactionIcon} email from {sender} on {date}.',
  EMAIL_INTEGRATION_SENT_SUMMARY:
    "{sender} sent an {interactionIcon} email to {recipients}{recipientsPlus, select, true { <strong>(+ {recipientsPlusNumber} more)</strong>} other {}}{hasCcRecipient, select, true { and CC'd {ccRecipient}} other {}}{showMoreCcRecipients, select, true { <strong>(+ {otherCcRecipientsCount} more)</strong>} other {}} on {date}.",
  EMAIL_INTEGRATION_SENT_BCC_ONLY_SUMMARY:
    "{sender} BCC'd an {interactionIcon} email to {bccRecipients} on {date}.",
  EMAIL_SUBJECT: 'Subject',
  EMAIL_FROM: 'From',
  EMAIL_TO: 'To',
  EMAIL_CC: 'CC',
  EMAIL_BCC: 'BCC',
  EMAIL_MESSAGE: 'Message',
  EMAIL_ATTACHMENTS: 'Attachments',
};
